// extracted by css-extract-rspack-plugin
export default {"aiIcon":"VOSox"};